import {Dispatch} from "redux";
import {CuratorialGroupActionType} from "../../reducers/curatorialGroupReducer/types";
import {
    GetGroupsAsync,
    GetGroupByUserAsync,
    AddGroupAsync,
    DeleteGroupByIdAsync,
    SetCuratorAsync,
    AddListenerAsync,
    RemoveListenerAsync
} from "../../../services/api-curatorial-grroup-service";

export const GetGroups = () => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await GetGroupsAsync();
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.ALL_GROUPS_LOADED,
            payload: response,
        });
    }
}

export const GetGroupByUser = () => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await GetGroupByUserAsync();
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.GROUP_LOADED,
            payload: response,
        });
    }
}

export const AddGroup = (params: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await AddGroupAsync(params);
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.FINISH_REQUEST,
        });
    }
}

export const DeleteGroupById = (id: number) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await DeleteGroupByIdAsync(id);
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.FINISH_REQUEST,
        });
    }
}

export const SetCurator = (groupId: number, curatorId: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await SetCuratorAsync(groupId, curatorId);
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.FINISH_REQUEST,
        });
    }
}

export const AddListener = (groupId: number, listenerId: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await AddListenerAsync(groupId, listenerId);
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.FINISH_REQUEST,
        });
    }
}

export const RemoveListener = (groupId: number, listenerId: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CuratorialGroupActionType.START_REQUEST});
        const data = await RemoveListenerAsync(groupId, listenerId);
        const {response} = data;
        dispatch({
            type: CuratorialGroupActionType.FINISH_REQUEST,
        });
    }
}
